module.exports = __webpack_public_path__ + "img/big_1_83.e542c73a.png";